// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_modal__\\+SQCi {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--table-row-white);
  border-radius: 10px;
  width: 740px;
  max-height: 90vh;
  overflow: auto;

  @media (max-width: 1024px) {
    width: calc(80% - 20px);
  }

  @media (max-width: 760px) {
    width: calc(100% - 20px);
  }
}

.styles_container__7S5Vp {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  width: 100%;
  padding: 24px;
  gap: 15px;
}

.styles_header__iMkWf {
  display: flex;
  gap: 20px;
}

.styles_title__veA1C {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.styles_title_group__PNQFA {
  font-size: 18px;
  font-weight: 500;
}

.styles_title_machine__PtQST {
  font-size: 20px;
  font-weight: 500;
}

.styles_content__H0ooK {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.styles_description__ivWFV {
  display: flex;
  flex-direction: column;
  width: 48%;
  gap: 20px;
  
  @media (max-width: 1024px) {
    width: 100%;
  }
}

.styles_description_title__1exag {
  font-size: 20px;
  opacity: 0.5;
  font-weight: 500;
}

.styles_description_task__I4uf3 {
  font-size: 14px;
  font-weight: 700;
}

.styles_description_task__desc__ISxAg {
  font-size: 14px;
  font-weight: 500;
}

.styles_fields__0Bc1b {
  display: flex;
  flex-direction: column;
  width: 48%;
  gap: 20px;
  
  @media (max-width: 1024px) {
    width: 100%;
  }
}

.styles_button_group__qTKYr {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
  gap: 10px;
  padding: 5px 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/ModalReportRepair/styles.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;;EAEd;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,SAAS;;EAET;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,SAAS;;EAET;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB","sourcesContent":[".modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: var(--table-row-white);\n  border-radius: 10px;\n  width: 740px;\n  max-height: 90vh;\n  overflow: auto;\n\n  @media (max-width: 1024px) {\n    width: calc(80% - 20px);\n  }\n\n  @media (max-width: 760px) {\n    width: calc(100% - 20px);\n  }\n}\n\n.container {\n  display: flex;\n  box-sizing: border-box;\n  flex-direction: column;\n  width: 100%;\n  padding: 24px;\n  gap: 15px;\n}\n\n.header {\n  display: flex;\n  gap: 20px;\n}\n\n.title {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n\n.title_group {\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.title_machine {\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.content {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n}\n\n.description {\n  display: flex;\n  flex-direction: column;\n  width: 48%;\n  gap: 20px;\n  \n  @media (max-width: 1024px) {\n    width: 100%;\n  }\n}\n\n.description_title {\n  font-size: 20px;\n  opacity: 0.5;\n  font-weight: 500;\n}\n\n.description_task {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.description_task__desc {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.fields {\n  display: flex;\n  flex-direction: column;\n  width: 48%;\n  gap: 20px;\n  \n  @media (max-width: 1024px) {\n    width: 100%;\n  }\n}\n\n.button_group {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 20px;\n  gap: 10px;\n  padding: 5px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `styles_modal__+SQCi`,
	"container": `styles_container__7S5Vp`,
	"header": `styles_header__iMkWf`,
	"title": `styles_title__veA1C`,
	"title_group": `styles_title_group__PNQFA`,
	"title_machine": `styles_title_machine__PtQST`,
	"content": `styles_content__H0ooK`,
	"description": `styles_description__ivWFV`,
	"description_title": `styles_description_title__1exag`,
	"description_task": `styles_description_task__I4uf3`,
	"description_task__desc": `styles_description_task__desc__ISxAg`,
	"fields": `styles_fields__0Bc1b`,
	"button_group": `styles_button_group__qTKYr`
};
export default ___CSS_LOADER_EXPORT___;
